import {
    createReferralsDataFetcherFactory,
    type ReferralsFetchTransformContext,
} from "./referralsDataFetcherFactory";
import { getNumericSharesFromSiteOrigins } from "./referralsWidgetFetcherUtils";

export default createReferralsDataFetcherFactory(
    (response: any, { orderedCompareDomains }: ReferralsFetchTransformContext) => {
        if (response?.Records && !response?.Data) {
            const normalizedRecords = response.Records.map((record: any) => {
                const normalizedShareList = Array.isArray(record?.ShareList)
                    ? record.ShareList
                    : getNumericSharesFromSiteOrigins(record?.SiteOrigins, orderedCompareDomains);

                return {
                    ...record,
                    ...(normalizedShareList ? { ShareList: normalizedShareList } : {}),
                };
            });
            return {
                ...response,
                Data: normalizedRecords,
            };
        }
        return response;
    },
);
